import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const SocialProof = lazyWithPreload(() => import('./SocialProof'))
